import { App } from '@ox/visits-ui/app';
import '@ox/visits-ui/styles/index.scss';
import { render } from 'preact';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
render(<App />, document.getElementById('app')!);
